import { useQuery } from '@tanstack/react-query';
import { SERVICENOW_CONFIG } from '@elementary/common-ui/constants/queryKeys';
import useFlags from '../useFlags';
import * as api from '../../services/settingsApi';

type Props = {
  envId?: string;
};

const useServiceNowIntegration = ({ envId }: Props) => {
  const { hasFlag } = useFlags();

  const servicenowConfigQuery = useQuery(
    [SERVICENOW_CONFIG, envId],
    () => api.fetchServiceNowConfig(envId!),
    {
      enabled: !!envId && hasFlag('ticketing'),
    },
  );

  return {
    servicenowConfigQuery,
  };
};

export default useServiceNowIntegration;
